module.exports = __webpack_public_path__ + "static/media/plane(8).9ebe02a8.PNG";